import React, { Component } from 'react';
import {
    emailRegex, alphaNumericRegex, websiteRegex, alphabetWithSpaceRegex, nameRegex,
    postalCodeRegex, getRoute, getProperDateMonth, mixPannelEvent
} from '../../../shared/helper.js';
import CustomerRegistrationJSX from './customerRegistration.jsx';
import {
    baseURL, uploadURL
} from "../../../constants/applicationConstants.js";
import axios from 'axios'
import signUpjson from "./customerRegistration.json";
import facebook from "../../../assets/images/facebook.svg";
import twitter from "../../../assets/images/twitter.svg";
import insta from "../../../assets/images/insta.svg";
import linkedin from "../../../assets/images/linkedin.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class CustomerRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                institutionName: "",
                legalInstitutionName: "",
                institutionEmail: "",
                segment: "",
                category: null,
                sizeOfInstitution: "",
                dateOfBirth: null,
                firstName: "",
                lastName: "",
                gender: "",
                email: "",
                altEmail: "",
                phone: "",
                postalCode: "",
                province: "",
                city: "",
                country: "",
                street: "",
                licenseNo: "",
                regulatory: "",
                primaryContact: "",
                secondaryContact: "",
                website: "",
                facebook: "",
                insta: "",
                twitter: "",
                linkedin: "",
                tempCat: null,
                occupation: "",
                annual_income: "",
                netWorth: "",
                annualHousehold: ""

            },
            isProcessing: false,
            formError: {},
            formSubmitButtonDisable: true,
            isLoading: false,
            fields: signUpjson,
            _URL: window.URL || window.webkitURL,
            imageName: null,
            imageUrl: "",
            fileInfo: null,
            profileImagePreviewUrl: null,
            isEditMode: false,
            image: "",
            sameError: false
        };

    }

    setDefaultValues = (data) => {
        const { name, legalName, gender, email, institutionSegmentId, instituteSizeId, postalCode, 
            stateCode, city, countryCode, address, regulatoryAssociation, website,
            instituteLicenses, instituteCategories, interests, imageUrl, alternativeEmail, dateOfBirth, phoneNumber, alternatePhoneNumber, occupation, annualIncome, annualHouseHoldIncome, netWorth } = data;
    
        const { firstName, lastName } = data;
    
        localStorage.setItem("emailCheck", email)
        localStorage.setItem("altCheck", alternativeEmail)
        const date = (dateOfBirth && dateOfBirth?.split('-')) || null;
    
        let tempArr = [];
    
        // Handle interests data properly
        if (interests && Array.isArray(interests)) {
            interests.forEach(cat => {
                tempArr.push({ 
                    label: cat.institutionCategory?.name || cat.name || cat.label, 
                    value: cat.institutionCategoryId || cat.id || cat.value 
                });
            });
        }
    
        // Handle instituteCategories data as fallback
        if (instituteCategories && Array.isArray(instituteCategories)) {
            instituteCategories.forEach(cat => {
                tempArr.push({ 
                    label: cat.name || cat.label, 
                    value: cat.institutionCategoryId || cat.id || cat.value 
                });
            });
        }
    
        console.log('Setting default category values:', tempArr); // Debug log
    
        this.setState({
            formData: {
                institutionName: name,
                occupation: occupation,
                annualHousehold: annualHouseHoldIncome,
                annual_income: annualIncome,
                netWorth: netWorth,
                legalInstitutionName: legalName,
                institutionEmail: email,
                email: email,
                segment: institutionSegmentId,
                tempCat: instituteCategories,
                sizeOfInstitution: instituteSizeId,
                dateOfBirth: date && {
                    day: date && parseInt(date[2]),
                    month: date && parseInt(date[1]),
                    year: date && parseInt(date[0])
                },
                gender: gender,
                firstName: firstName,
                lastName: lastName,
                altEmail: alternativeEmail,
                postalCode: postalCode,
                province: stateCode,
                city: city,
                country: countryCode,
                street: address,
                licenseNo: instituteLicenses?.map(x => x.licenseNumber)?.join(','),
                regulatory: regulatoryAssociation,
                primaryContact: phoneNumber,
                secondaryContact: alternatePhoneNumber,
                website: website,
                category: tempArr // Use the properly formatted array
            },
            isLoading: false,
            isEditMode: true,
            imageUrl: imageUrl,
            image: imageUrl && imageUrl,
        }, () => {
            this.getSegments();
            this.isFromSubmissionBlock();
        })
    }

    componentDidMount = () => {
        this.setState({ isLoading: true })
        let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
        // if (!token) {
        //     this.props.history.push("/");
        //   }

        localStorage.removeItem("altCheck")
        localStorage.removeItem("emailCheck")
        let customerId = localStorage.getItem("customerId") && JSON.parse(localStorage.getItem("customerId"))

        let verifyInstituteID = localStorage.getItem('VerifyInstituteID');
        let data = {
            customerId: customerId
        }
        if (verifyInstituteID) {
            axios.get(`${baseURL}/institute/${verifyInstituteID}/details`, {
                headers: {
                    'x-access-token': token
                }
            }).then(res => {
                this.setDefaultValues(res.data.data)
            })
        }


        else if (token && customerId) {
            axios.get(`${baseURL}/customerbyid/${customerId}`, data).then(res => {
                this.setDefaultValues(res.data.data);
            })
        }
        else {
            this.getSegments();
        }

        axios.get(`${baseURL}/countries`).then(res => {
            this.getUpdateJSON('country', res.data.data);
        })

        axios.get(`${baseURL}/states`).then(res => {
            this.getUpdateJSON('province', res.data.data);
        })

        axios.get(`${baseURL}/institutionSizes`).then(res => {
            this.getUpdateJSON('sizeOfInstitution', res.data.data);
            this.setState({ isLoading: false })
        })
        this.getCategories()
    }

    getCategories = () => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ category: res.data.data, isLoading: false })
            this.getUpdateJSON('category', res.data.data);

        })
    }

    getSegments = () => {
        axios.get(`${baseURL}/instituteSegments`).then(res => {
            this.getUpdateJSON('segment', res.data.data);
            let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
            let instituteId = localStorage.getItem("instituteId") && JSON.parse(localStorage.getItem("instituteId"))
            instituteId = localStorage.getItem('VerifyInstituteID') ?? instituteId

            if (token && instituteId) {
                const category = res.data.data.filter(item => item.institutionSegmentId === this.state.formData.segment)[0]?.institutionCategories;
                this.getUpdateJSON('category', category);

                let tempArr = [];

                category?.forEach(cat => {
                    this.state.formData.tempCat?.forEach(abc => {
                        if (cat.institutionCategoryId === abc.institutionCategoryId)
                            tempArr.push({ label: cat.name, value: cat.institutionCategoryId });
                    })
                })
                this.setState({ formData: { ...this.state.formData, category: [...tempArr] } }, () => this.isFromSubmissionBlock())
            }
        })
    }

    getUpdateJSON = (label, values) => {
        let dropdownOptions = [{ label: 'Select', value: null }];
    
        if (label === 'segment') {
            values?.forEach(value => {
                dropdownOptions.push({
                    label: value.name,
                    value: value.institutionSegmentId,
                    category: value.institutionCategories
                });
            });
        } else if (label === 'category') {
            dropdownOptions = [];
            values?.forEach(value => {
                dropdownOptions.push({
                    label: value.name,
                    value: value.institutionCategoryId,
                    icon:value.icon
                });
            });
        } else if (label === 'sizeOfInstitution') {
            values?.forEach(value => {
                dropdownOptions.push({
                    label: value.size,
                    value: value.institutionSizeId
                });
            });
        } else if (label === 'country') {
            values?.forEach(value => {
                dropdownOptions.push({
                    label: value.name,
                    value: value.countryCode
                });
            });
        } else if (label === 'province') {
            values?.forEach(value => {
                dropdownOptions.push({
                    label: value.name,
                    value: value.stateCode
                });
            });
        }
    
        let tempArr = [...this.state.fields];
        tempArr.forEach((data, index) => {
            if (data.name === label) {
                tempArr[index] = { ...tempArr[index], options: dropdownOptions };
            } else {
                data.fields?.forEach((data1, index1) => {
                    if (data1.name === label) {
                        data.fields[index1] = { ...data.fields[index1], options: dropdownOptions };
                    }
                });
            }
        });
    
        this.setState({ fields: tempArr });
    }
    

    handleChange = (e, item) => {
        if (item.name === 'segment') {
            this.onSegmentChange(item, e.value)
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [item.name]: e.value,
                        category: []
                    },
                    formError: {
                        ...this.state.formError,
                        [item.name]: "regx",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
        else if (item.name === 'category') {
            // Handle multiselect category checkboxes
            let categoryValue = [...(this.state.formData.category || [])];
            
            if (e.target && e.target.type === 'checkbox') {
                const categoryId = item.value || item.institutionCategoryId;
                const categoryLabel = item.label || item.name;
                
                if (e.target.checked) {
                    // Add to category if checked and not already present
                    const exists = categoryValue.some(cat => 
                        (cat.value || cat.institutionCategoryId) === categoryId
                    );
                    if (!exists) {
                        categoryValue.push({ 
                            label: categoryLabel, 
                            value: categoryId,
                            institutionCategoryId: categoryId
                        });
                    }
                } else {
                    // Remove from category if unchecked
                    categoryValue = categoryValue.filter(cat => 
                        (cat.value || cat.institutionCategoryId) !== categoryId
                    );
                }
            } else if (Array.isArray(e)) {
                // Handle react-select multiselect (if you decide to use it later)
                categoryValue = e;
            }
            
            console.log('Category value being set:', categoryValue); // Debug log
            
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [item.name]: categoryValue,
                    },
                    formError: {
                        ...this.state.formError,
                        [item.name]: "regx",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
        else {
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [item.name]: e.value
                    },
                    formError: {
                        ...this.state.formError,
                        [item.name]: "regx",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    }

    onSegmentChange = (items, value) => {
        const category1 = items?.options?.filter(item => item.value === Number(value))[0].category;
        this.getUpdateJSON('category', category1);
    }

    onInputChangeHandler = (e, item = '') => {
        let name = e.target.name;
        let value = e.target.value;
        if (value) {
            if (name === "email" || name === "altEmail") {
                if (name === "email") {
                    localStorage.setItem("emailCheck", value)
                }
                if (name === "altEmail") {
                    localStorage.setItem("altCheck", value)
                }
                let emailCheck = localStorage.getItem("emailCheck")
                let altCheck = localStorage.getItem("altCheck")
                if (emailCheck === altCheck) {
                    this.setState({ sameError: true })
                } else {
                    this.setState({ sameError: false })

                }
            }
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );

            } else {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );

            }
        } else {
            if (name === "email" || name === "altEmail") {
                if (name === "email") {
                    localStorage.setItem("emailCheck", value)
                }
                if (name === "altEmail") {
                    localStorage.setItem("altCheck", value)
                }
                let emailCheck = localStorage.getItem("emailCheck")
                let altCheck = localStorage.getItem("altCheck")
                if (emailCheck === altCheck) {
                    this.setState({ sameError: true })
                } else {
                    this.setState({ sameError: false })

                }
            }
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    };


    onTouchHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value === "") {
            this.setState({
                formError: {
                    ...this.state.formError,
                    [name]: "req",
                },
            });
        } else {
            if (!this.inputRegexValidation(name, value)) {
                this.setState({
                    formError: {
                        ...this.state.formError,
                        [name]: "regx",
                    },
                });
            }
        }
    };

    getProperPhoneNumber = (value) => {

        if (!isNaN(value)) {
            return value
        }

        const number = value.split(' ');
        return number[0].replace('(', '').replace(')', '') + number[1] + number[2]
    }

    inputRegexValidation = (name, value) => {
        if (name === 'postalCode')
            return postalCodeRegex.test(value);
        if (name === 'licenseNo')
            return alphaNumericRegex.test(value);
        else if (name === 'legalInstitutionName' || name === 'regulatory' || name === 'city')
            return alphabetWithSpaceRegex.test(value);
        else if (name === 'firstName' || name === 'lastName' || name === 'city')
            return nameRegex.test(value);
        else if (name === "email" || name === "altEmail")
            return emailRegex.test(value);
        else if (name === "phone" || name === "primaryContact" || name === "secondaryContact")
            return !this.getProperPhoneNumber(value)?.includes('_');
        else if (name === "website")
            return websiteRegex.test(value);
        else if (name === 'facebook')
            return value.includes('facebook')
        else if (name === 'insta')
            return value.includes('instagram')
        else if (name === 'twitter')
            return (value.includes('twitter') || value.includes('x.'))
        else if (name === 'linkedin')
            return value.includes('linkedin')

        return true;
    };

    isFromSubmissionBlock = () => {
        let {
            altEmail, firstName, lastName, email, postalCode, street, category, province, city, country, primaryContact, secondaryContact } = this.state.formData;
        
        // Check if category has valid data
        const hasValidCategory = category && Array.isArray(category) && category.length > 0;
        
        console.log('Form validation - category:', category, 'hasValidCategory:', hasValidCategory); // Debug log
        
        if (
            firstName && lastName && email && postalCode && street &&
            province && city && country && hasValidCategory) {
    
            if (
                this.inputRegexValidation("firstName", firstName) &&
                this.inputRegexValidation("lastName", lastName) &&
                this.inputRegexValidation("email", email) &&
                this.inputRegexValidation("primaryContact", primaryContact) &&
                this.inputRegexValidation("postalCode", postalCode) &&
                this.inputRegexValidation("street", street) &&
                this.inputRegexValidation("province", province) &&
                this.inputRegexValidation("country", country) &&
                this.inputRegexValidation("city", city) &&
    
                // non-required fields
                (altEmail ? this.inputRegexValidation("altEmail", altEmail) : true) &&
                (secondaryContact ? this.inputRegexValidation("secondaryContact", secondaryContact) : true) &&
                (primaryContact ? this.inputRegexValidation("primaryContact", primaryContact) : true)
    
            ) {
                this.setState({
                    formSubmitButtonDisable: false,
                });
            } else {
                this.setState({
                    formSubmitButtonDisable: true,
                });
            }
        } else {
            this.setState({
                formSubmitButtonDisable: true,
            });
        }
    };

    onDateChange = (date) => {
        this.setState(
            {
                formData: {
                    ...this.state.formData,
                    dateOfBirth: date,
                }
            },
            () => this.isFromSubmissionBlock()
        );
    }

    getSocialImage = (item) =>
        item.name === 'facebook' ? facebook : item.name === 'insta' ? insta : item.name === 'twitter' ? twitter : linkedin

    onNextButtonClick = () => {
        this.setState({
            isLoading: true
        })
        let formData1 = new FormData();

        if (this.state.fileInfo) {
            formData1.append('image', this.state.fileInfo)
            formData1.append('imageCategory', "customer")

            axios.post(`${uploadURL}/upload-file`, formData1).then(resp => {
                if (resp.status === 200) {
                    this.setState({ image: resp.data.filename })
                    setTimeout(() => {
                        this.onNextButtonClick1()
                    }, 2000)
                }
            }).catch(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
        else this.onNextButtonClick1();
    };


    onNextButtonClick1 = () => {
        localStorage.removeItem("altCheck")
        localStorage.removeItem("emailCheck")
        this.setState({
            isLoading: true
        })
    
        let image = this.state.image;
    
        const { gender, dateOfBirth, category, firstName, lastName, city, postalCode, street, province, country, email,
            altEmail, primaryContact, secondaryContact, occupation, annual_income, annualHousehold, netWorth } = this.state.formData;
    
        const status = localStorage.getItem('verificationStatus');
    
        // Fix: Ensure category data is properly formatted for interests
        let interests = [];
        console.log("gggggggggg",category)
        if (category && Array.isArray(category)) {
            interests = category.map(cat => {
                // Handle both {value: id} and {institutionCategoryId: id} formats
                return cat.value || cat.institutionCategoryId || cat;
            }).filter(id => id !== null && id !== undefined);
        }
    
        console.log('Category data:', category); // Debug log
        console.log('Interests being sent:', interests); // Debug log
    
        const payloadData1 = {
            "firstName": firstName,
            "lastName": lastName,
            "email": email,
            "alternativeEmail": altEmail,
            "phoneNumber": this.getProperPhoneNumber(primaryContact) || null,
            "alternatePhoneNumber": secondaryContact,
            "dateOfBirth": (dateOfBirth && `${dateOfBirth?.year}-${getProperDateMonth(dateOfBirth?.month)}-${getProperDateMonth(dateOfBirth.day)}`) || null,
            "gender": gender,
            "address": street ,
            "city": city,
            "stateCode": province,
            "countryCode": country,
            "postalCode": postalCode.toString(),
            "occupation": occupation,
            "annualIncome": annual_income,
            "interests": interests, // Use the properly formatted interests array
            "netWorth": netWorth,
            "occupationCountry": country,
            "annualHouseHoldIncome": annualHousehold,
            imageUrl: image
        }
    
        // Rest of the function remains the same...
        let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
        let customerId = localStorage.getItem("customerId") && JSON.parse(localStorage.getItem("customerId"))
    
        const payloadData = image ? { ...payloadData1, imageUrl: image } : { ...payloadData1 }
    
        let verifyInstituteID = localStorage.getItem('VerifyInstituteID');
    
        if (verifyInstituteID) {
            axios.put(`${baseURL}/institute/${verifyInstituteID}/verifyAccount`, { ...payloadData, status: 'verified' }, {
                headers: {
                    'x-access-token': token
                }
            }).then(res => {
                if (res.data.success) {
                    toast.success('Account Verified');
                    setTimeout(() => {
                        this.props.history.push('./admin/manageUnverifiedInstitute')
                    }, 1000)
                    window.scrollTo(0, 0);
                    this.setState({
                        isLoading: false
                    })
                }
                else {
                    toast.error(res.data?.error.message)
                    this.setState({
                        isLoading: false
                    })
                }
            }).catch(err => {
                toast.error(err?.response.data?.error.message)
                this.setState({
                    isLoading: false
                })
            })
        } else if (customerId) {
            let flowType = localStorage.getItem('flowName') ?? ''
            axios.put(`${baseURL}/customer/${customerId}/onboarding`, {
                "tokenValidate": token, ...payloadData
            }).then(res => {
                if (res.data.success) {
                    localStorage.setItem("token", JSON.stringify(res.data?.data?.tokenValidate));
                    localStorage.setItem("email", JSON.stringify(this.state.formData.email));
                    localStorage.setItem("customerId", JSON.stringify(res.data?.data?.customerId));
                    if (!flowType) {
                        localStorage.setItem('flowName', 'customer')
                        localStorage.setItem('flowType', 'customer')
                        flowType = 'customer'
                    }
                    flowType = (status === 'unVerified' ? 'unVerified' : flowType)
                    setTimeout(() => {
                        this.props.history.push(getRoute(flowType, 'customerRegistration'));
                        window.location.reload()
                    }, 2000);
    
                    window.scrollTo(0, 0);
                    this.setState({
                        isLoading: false
                    })
                }
                else {
                    toast.error(res.data.error.message)
                    this.setState({
                        isLoading: false
                    })
                }
            }).catch(err => {
                toast.error(err.response.data.error.message)
                this.setState({
                    isLoading: false
                })
            })
        }
        else {
            let flowType = localStorage.getItem('flowName') ?? ''
            axios.post(`${baseURL}/customer`, payloadData).then(res => {
                if (res.data.success) {
                    localStorage.setItem("token", JSON.stringify(res.data?.data?.tokenValidate));
                    localStorage.setItem("email", JSON.stringify(this.state.formData.email));
                    localStorage.setItem("customerId", JSON.stringify(res.data?.data?.customerId));
                    mixPannelEvent({
                        eventName: "signup_initiated",
                        data: {
                          name: "signup_initiated",
                          user: "customer"
                        }
                      })
                    if (!flowType) {
                        localStorage.setItem('flowName', 'customer')
                        localStorage.setItem('flowType', 'customer')
                        flowType = 'customer'
                    }
                    flowType = (status === 'unVerified' ? 'unVerified' : flowType)
                    this.props.history.push(getRoute(flowType, 'customerRegistration'));
                    window.scrollTo(0, 0);
                    this.setState({
                        isLoading: false
                    })
                }
                else {
                    toast.error(res.data?.error.message)
                    mixPannelEvent({
                        eventName: "signup_failed",
                        data: {
                          name: res.data?.error.message,
                          user: "customer"
                        }
                      })
                    this.setState({
                        isLoading: false
                    })
                }
            }).catch(err => {
                mixPannelEvent({
                    eventName: "signup_failed",
                    data: {
                      name: err?.response.data?.error.message,
                      user: "customer"
                    }
                  })
                toast.error(err?.response.data?.error.message)
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    validFileName = (name) => name.includes('.jpeg') || name.includes('.jpg') || name.includes('.png');

    onFileChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        
        if (e.target.files[0]?.size) {
            if (e.target.files[0]?.size < 512000) { // 500 KB check
                if (e.target.files[0] && this.validFileName(e.target.files[0].name)) {
                    reader.onloadend = () => {
                        const img = new Image();
                        img.src = reader.result;
                        
                        img.onload = () => {
                            const { width, height } = img;
                            
                            // Check if the dimensions are exactly 800x800 px                            
                            if (width/height === 1) {
                                this.setState({ fileInfo: e.target.files[0] }, () => this.isFromSubmissionBlock());
                                this.setState({ profileImagePreviewUrl: URL.createObjectURL(e.target.files[0]) });
                                this.setState({ imageName: e.target.files[0].name });
                            } else {
                                e.target.value = null
                                toast.error('Image must have exactly 1:1 ratio.');
                            }
                        };
                    };
                } else {
                    toast.error('.jpeg/.jpg/.png format required');
                }
            } else {
                toast.error('File should be less than 500 KB.');
            }
        }
    }
    

    render() {
        return (
            <>
                <CustomerRegistrationJSX
                    field={this.state.fields}
                    formData={this.state.formData}
                    onInputChangeHandler={this.onInputChangeHandler}
                    onTouchHandler={this.onTouchHandler}
                    formSubmitButtonDisable={this.state.formSubmitButtonDisable}
                    formError={this.state.formError}
                    formSubmitHandler={this.formSubmitHandler}
                    onDateChange={this.onDateChange}
                    handleChange={this.handleChange}
                    onNextButtonClick={this.onNextButtonClick}
                    getSocialImage={this.getSocialImage}
                    onFileChange={this.onFileChange}
                    image={this.state.image}
                    imageName={this.state.imageName}
                    imgURL={this.state.imageUrl}
                    profileImagePreviewUrl={this.state.profileImagePreviewUrl}
                    editMode={this.state.isEditMode}
                    sameError={this.state.sameError}
                />
                {/* {this.state.isLoading && <Loader />} */}
                <ToastContainer />
            </>
        )
    }
}

export default CustomerRegistration;
